export default __webpack_public_path__ + "static/media/round_arrow.d91873d0.svg";